import { createSlice } from '@reduxjs/toolkit';
import { getVisibleColumns } from '../../../../services/ObjectConfiguration/ObjectConfiguration.service';
import { LoadingStatus, SortDirection } from '../../../../utils/constants';
import { updateEndDate, updateStartDate } from '../../../../utils/dateTimeUtls';
import { getStartDateWithTime, getEndDateWithTime } from '../../../../utils/constants/datetime';

const applySaveFilterHandler = (state, action) => {
  const fields = action.payload;
  if (!Array.isArray(fields) || fields.length === 0) {
    return;
  }

  const fieldObj = {};
  fields.forEach(({ Field, Value, Text }) => {
    fieldObj[Field] = Value;
    if (Text) {
      fieldObj[`${Field}_Text`] = Text;
    }
  });

  [
    'sampleName',
    'sampleDescription',
    'sampleSource',
    'sampleDateCreatedFrom',
    'sampleDateCreatedTo',
    'samplingDateFrom',
    'samplingDateTo',
    'sampleStatusName',
    'project',
    'sentFrom',
    'jobName',
    'sampleNumber',
    'bunkeringCountry',
    'fuelSupplier',
    'fleetName',
    'vesselName',
    'imoNumber',
    'submissionType',
    'productType',
    'grade',
    'bunkeringDateFrom',
    'bunkeringDateTo',
    'sealNumber',
    'arrivalDateAtLabFrom',
    'arrivalDateAtLabTo',
    'statusId',
    'statusDateFrom',
    'statusDateTo',
    'contractId',
    'sampleType',
    'sampleCategory',
  ].forEach((fieldName) => {
    const fieldValue = fieldObj[fieldName];
    state.searchFilter[fieldName] = fieldValue || '';
  });

  const selectedLocationValue = fieldObj.selectedLocation;
  if (selectedLocationValue) {
    state.searchFilter['selectedLocation'] = {
      id: selectedLocationValue,
      text: fieldObj.selectedLocation_Text || '',
    };
  } else {
    state.searchFilter['selectedLocation'] = null;
  }

  const selectedClientValue = fieldObj.selectedClient;
  if (selectedClientValue) {
    state.searchFilter['selectedClient'] = {
      id: selectedClientValue,
      text: fieldObj.selectedClient_Text || '',
    };
  } else {
    state.searchFilter['selectedClient'] = null;
  }

  const selectedSupplierValue = fieldObj.selectedSupplier;
  if (selectedSupplierValue) {
    state.searchFilter['selectedSupplier'] = {
      id: selectedSupplierValue,
      text: fieldObj.selectedSupplier_Text || '',
    };
  } else {
    state.searchFilter['selectedSupplier'] = null;
  }

  const selectedSampleTypeValue = fieldObj.sampleType;
  if (selectedSampleTypeValue) {
    state.searchFilter['sampleType'] = {
      id: selectedSampleTypeValue,
      text: fieldObj.sampleType.text || ''
    };
  } else {
    state.searchFilter['sampleType'] = null;
  }

  const selectedSampleCategoryValue = fieldObj.sampleCategory;
  if (selectedSampleCategoryValue) {
    state.searchFilter['sampleCategory'] = {
      id: selectedSampleCategoryValue,
      text: fieldObj.sampleCategory.text || ''
    };
  } else {
    state.searchFilter['sampleCategory'] = null;
  }

  const selectedSubmissionTypeValue = fieldObj.SubmissionType;
  if (selectedSubmissionTypeValue) {
    state.searchFilter['submissionType'] = {
      id: selectedSubmissionTypeValue.id,
      text: fieldObj.SubmissionType.text || ''
    };
  } else {
    state.searchFilter['submissionType'] = null;
  }

  const selectedProductTypeValue = fieldObj.ProductType;
  if (selectedProductTypeValue) {
    state.searchFilter['productType'] = {
      id: selectedProductTypeValue.id,
      text: fieldObj.ProductType.text || ''
    };
  } else {
    state.searchFilter['productType'] = null;
  }

  const selectedFuelSupplierValue = fieldObj.FuelSupplier;
  if (selectedFuelSupplierValue) {
    state.searchFilter['fuelSupplier'] = {
      id: selectedFuelSupplierValue.id,
      text: fieldObj.FuelSupplier.text || ''
    };
  } else {
    state.searchFilter['fuelSupplier'] = null;
  }

  const selectedVesselNameValue = fieldObj.VesselName;
  if (selectedVesselNameValue) {
    state.searchFilter['vesselName'] = {
      id: selectedVesselNameValue.id,
      text: fieldObj.VesselName.text || null
    };
  } else {
    state.searchFilter['vesselName'] = null;
  }

  const selectedFleetNameValue = fieldObj.FleetName;
  if (selectedFleetNameValue) {
    state.searchFilter['fleetName'] = {
      id: selectedFleetNameValue.id,
      text: fieldObj.FleetName.text || ''
    };
  } else {
    state.searchFilter['fleetName'] = null;
  }

  const selectedImoNumberValue = fieldObj.IMONumber;
  if (selectedImoNumberValue) {
    state.searchFilter['imoNumber'] = {
      id: selectedImoNumberValue.id,
      text: fieldObj.IMONumber.text || ''
    };
  } else {
    state.searchFilter['imoNumber'] = null;
  }

  const selectedStatusValue = fieldObj.Status;
  if (selectedStatusValue) {
    state.searchFilter['statusId'] = {
      id: selectedStatusValue.id,
      text: fieldObj.Status.text || ''
    };
  } else {
    state.searchFilter['statusId'] = null;
  }

  const selectedGradeValue = fieldObj.Grade;
  if (selectedGradeValue) {
    state.searchFilter['grade'] = {
      id: selectedGradeValue.id,
      text: fieldObj.Grade.text || ''
    };
  } else {
    state.searchFilter['grade'] = null;
  }

  const selectedContractIdValue = fieldObj.ContractId;
  if (selectedContractIdValue) {
    state.searchFilter['contractId'] = {
      id: selectedContractIdValue.id,
      text: fieldObj.ContractId.text || ''
    };
  } else {
    state.searchFilter['contractId'] = null;
  }

  const selectedBunkeringCountryValue = fieldObj.BunkeringCountry;
  if (selectedBunkeringCountryValue) {
    state.searchFilter['bunkeringCountry'] = {
      id: selectedContractIdValue.id,
      text: fieldObj.BunkeringCountry.text || ''
    };
  } else {
    state.searchFilter['bunkeringCountry'] = null;
  }

  const selectedArrivalDateAtLabFrom = fieldObj.ArrivalDateAtLabFrom;
  if (selectedArrivalDateAtLabFrom) {
    state.searchFilter['arrivalDateAtLabFrom'] = selectedArrivalDateAtLabFrom;
  } else {
    state.searchFilter['arrivalDateAtLabFrom'] = null;
  }

  const selectedSealNumberValue = fieldObj.SealNumber;
  if (selectedSealNumberValue) {
    state.searchFilter['sealNumber'] = selectedSealNumberValue;
  } else {
    state.searchFilter['arrivalDateAtLabFrom'] = '';
  }

  const selectedStatusDateFromValue = fieldObj.StatusDateFrom;
  if (selectedStatusDateFromValue) {
    state.searchFilter['statusDateFrom'] = selectedStatusDateFromValue;
  } else {
    state.searchFilter['statusDateFrom'] = null;
  }

  const selectedStatusDateToValue = fieldObj.StatusDateTo;
  if (selectedStatusDateToValue) {
    state.searchFilter['statusDateTo'] = selectedStatusDateToValue;
  } else {
    state.searchFilter['statusDateTo'] = null;
  }

  const selectedBunkeringDateFromValue = fieldObj.BunkeringDateFrom;
  if (selectedBunkeringDateFromValue) {
    state.searchFilter['bunkeringDateFrom'] = selectedBunkeringDateFromValue;
  } else {
    state.searchFilter['bunkeringDateFrom'] = null;
  }

  const selectedBunkeringDateToValue = fieldObj.BunkeringDateTo;
  if (selectedBunkeringDateToValue) {
    state.searchFilter['bunkeringDateTo'] = selectedBunkeringDateToValue;
  } else {
    state.searchFilter['bunkeringDateTo'] = null;
  }

  const selectedArrivalDateAtLabTo = fieldObj.ArrivalDateAtLabTo;
  if (selectedArrivalDateAtLabTo) {
    state.searchFilter['arrivalDateAtLabTo'] = selectedArrivalDateAtLabTo;
  } else {
    state.searchFilter['arrivalDateAtLabTo'] = null;
  }

  const selectedProjectValue = fieldObj.project;
  if (selectedProjectValue) {
    state.searchFilter['project'] = {
      id: selectedProjectValue,
      text: fieldObj.project_Text || '',
    };
  } else {
    state.searchFilter['project'] = null;
  }
};

const initialFilterState = {
  sampleName: '',
  sampleDescription: '',
  sampleSource: '',
  samplingDateFrom: '',
  samplingDateTo: '',
  sampleDateCreatedFrom: updateStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1))).toISOString(),
  sampleDateCreatedTo: updateEndDate(new Date()).toISOString(),
  sampleStatusName: '',

  selectedSupplier: null,
  selectedLocation: null,
  selectedClient: null,
  project: null,
  sentFrom: null,
  jobName: '',
  sampleNumber: '',

  page: 0,
  pageSize: 20,
  sortColumn: 'CreatedOn',
  sortDirection: SortDirection.Desc,
  bunkeringCountry: null,
  fuelSupplier: null,
  fleetName: null,
  vesselName: null,
  imoNumber: null,
  submissionType: null,
  productType: null,
  grade: null,
  bunkeringDateFrom: null,
  bunkeringDateTo: null,
  sealNumber: '',
  arrivalDateAtLabFrom: null,
  arrivalDateAtLabTo: null,
  statusId: null,
  statusDateFrom: null,
  statusDateTo: null,
  contractId: null,
  sampleType: null,
  sampleCategory: null,
};

const initialState = {
  searchFilter: {
    sampleName: '',
    sampleDescription: '',
    sampleSource: '',
    samplingDateFrom: '',
    samplingDateTo: '',
    sampleDateCreatedFrom: updateStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1))).toISOString(),
    sampleDateCreatedTo: updateEndDate(new Date()).toISOString(),
    sampleStatusName: '',

    selectedSupplier: null,
    selectedLocation: null,
    selectedClient: null,
    project: null,
    sentFrom: null,
    jobName: '',
    sampleNumber: '',
    bunkeringCountry: null,
    fuelSupplier: null,
    fleetName: null,
    vesselName: null,
    imoNumber: null,
    submissionType: null,
    productType: null,
    grade: null,
    bunkeringDateFrom: null,
    bunkeringDateTo: null,
    sealNumber: '',
    arrivalDateAtLabFrom: getStartDateWithTime(new Date(new Date().setMonth(new Date().getMonth() - 1))).toISOString(),
    arrivalDateAtLabTo: getEndDateWithTime(new Date()).toISOString(),
    statusId: null,
    statusDateFrom: null,
    statusDateTo: null,
    contractId: null,
    sampleType: null,
    sampleCategory: null,

    page: 0,
    pageSize: 20,
    sortColumn: 'CreatedOn',
    sortDirection: SortDirection.Desc,
  },

  isFilterVisible: true,
  isSearching: false,
  sampleList: [],
  sampleCount: 0,

  loadingSampleColumnStatus: LoadingStatus.Idle,
  visibleGridColumns: [],
  mergedColumns: [],

  isFilterPresetLoaded: false,
  savedFilterPresetList: [],
};

const sampleSearchSlice = createSlice({
  name: 'sampleSearch',
  initialState,
  reducers: {
    toggleFilterPanelVisibility(state) {
      state.isFilterVisible = !state.isFilterVisible;
    },
    applySavedFilter(state, action) {
      applySaveFilterHandler(state, action);
    },
    updateSearchFilterValues(state, action) {
      const { propName, propValue } = action.payload;
      state.searchFilter[propName] = propValue;
    },
    resetSearchFilter(state) {
      state.searchFilter = { ...initialFilterState };
    },
    updateIsSearching(state, action) {
      state.isSearching = !!action.payload;
    },
    updateSearchResult(state, action) {
      const { sampleList, sampleCount } = action.payload;
      state.sampleList = sampleList;
      state.sampleCount = sampleCount;
    },

    updateLoadingColumnSettingStatus(state, action) {
      state.loadingSampleColumnStatus = action.payload;
    },

    updateVisibleGridColumns(state, action) {
      state.visibleGridColumns = action.payload;
    },
    updateMergedGridColumns(state, action) {
      state.mergedColumns = action.payload;
    },
    updateUserColumnSettings(state, action) {
      state.mergedColumns = action.payload;
      state.visibleGridColumns = getVisibleColumns(action.payload);
    },

    updateSavedFilterPresetList(state, action) {
      state.isFilterPresetLoaded = true;
      state.savedFilterPresetList = action.payload;
    },
    updatingSorting(state, action) {
      const { sortBy, sortOrder } = action.payload;
      state.searchFilter['sortColumn'] = sortBy;
      state.searchFilter['sortDirection'] = sortOrder;
    },
  },
});

export const sampleSearchActions = sampleSearchSlice.actions;
export default sampleSearchSlice.reducer;
